import { AdjustmentsConfigDto, BorrowerContractFunnelDto, BorrowerHeaderTabDto, BorrowerNaturalPersonDto, LoanConfigurationDto, LoanConfigWithGuaranteeIdsDto, SidebarComponentDto, ConfigurableParameterDto1 } from "api/borrower";
import { BorrowerContractFunnelV2Dto, GuaranteeDto } from "api/pricing"
import { BorrowerCartItemDto } from "api/shopping-cart";

// Types locaux pour les fees et commissions de la sidebar (componentConfig)
// Définis localement car ils sont utilisés pour parser le componentConfig générique
export interface ApiFeesDto {
  id: string;
  code: string;
  label: string;
  value: number;
  parameters?: ConfigurableParameterDto1;
  warningMessage?: string;
}

export interface ApiIdLabel {
  id: string;
  label: string;
}

// Types pour les filtres génériques de la sidebar
export type SidebarFilterType = 'INSURER' | 'SUPPORT_TYPE' | string;

export interface SideMenuFilterItem {
  id: string;
  label: string;
  value: boolean;
}

export interface SideMenuFilter {
  type: SidebarFilterType;
  title: string;
  items: SideMenuFilterItem[];
}

// Mapping des types de filtre vers les champs du contractFunnel
// Retourne la valeur du champ correspondant pour comparaison avec les IDs de filtre
export const FILTER_TYPE_TO_FUNNEL_FIELD: Record<SidebarFilterType, (funnel: BorrowerContractFunnelV2Dto) => string | undefined> = {
  'INSURER': (funnel) => funnel.product?.owner?.id,
  'SUPPORT_TYPE': (funnel) => funnel.supportId,
  // CI_CRD: basé sur cotisationTypeId
  'CI_CRD': (funnel) => funnel.cotisationTypeId ?? undefined,
};

// Type pour la configuration des composants sidebar
export interface PricingFilterConfig {
  type: SidebarFilterType;
  title: string;
  items: Array<{ id: string; label: string }>;
}

export interface PricingVariableAndFeesConfig {
  variables?: Array<unknown>;
  fees?: ApiFeesDto[];
  borrowersCommissions?: ApiIdLabel[];
  borrowerCommissionValue?: string;
}

// Type pour stocker les composants sidebar bruts de l'API
export interface SidebarComponents {
  pricingFilters: PricingFilterConfig[];
  variablesAndFees?: PricingVariableAndFeesConfig;
  raw: SidebarComponentDto[];
}


export interface PersonCartItem extends BorrowerHeaderTabDto {
  items: BorrowerContractFunnelV2Dto[]
}

export interface PendingLoanConfig extends LoanConfigWithGuaranteeIdsDto {
  loanId: string
}

export interface MainBorrowerPricingState {
  //Init Borrower Pricing Data
  borrowerId: string | null
  borrowerProjectId: string | null
  insured: BorrowerNaturalPersonDto | null
  loansConfigurations: Array<LoanConfigurationDto>
  tabs: Array<BorrowerHeaderTabDto>
  contractFunnels: BorrowerContractFunnelV2Dto[]
  globalWarningMessages: string[]

  // Fetch Funnels Data
  filters: SideMenuFilter[]
  guaranteesReferential: Array<GuaranteeDto>;
  fees?: ApiFeesDto[];
  borrowersCommissions?: ApiIdLabel[];
  borrowerCommissionValue?: string;

  // Pricing interface data
  pendingLoanConfigs: LoanConfigWithGuaranteeIdsDto[]
  adjustmentsConfig: AdjustmentsConfigDto
  isProMode: boolean
  shoppingCart: BorrowerCartItemDto[]

  isPriceLoading: boolean
  isContractFunnelsLoading: boolean
  isLoading: boolean
  error: string | null
}

export interface InitBorrowerPricingData {
  borrowerProjectId: string
  borrowerId: string
  insured: BorrowerNaturalPersonDto
  loansConfigurations: Array<LoanConfigurationDto>
  tabs: Array<BorrowerHeaderTabDto>
}

export interface FetchBorrowerFunnelsReferential {
  filters?: SideMenuFilter[],
  guaranteesReferential?: Array<GuaranteeDto>;
  fees?: ApiFeesDto[];
  borrowersCommissions?: ApiIdLabel[];
  borrowerCommissionValue?: string;
}
